import React from "react";
import { Link } from "react-router-dom";
import books from "./books"; // Import your book data

const BookList = () => {
  return (
    <div className="d-flex flex-wrap justify-content-center gap-5 mt-2">
      {books.map((book, index) => (
        <Link
          to={`/book/${index}`}
          key={index}
          style={{ textDecoration: "none" }}
        >
          <div className="card border-0" style={{ width: "157px" }}>
            <img
              src={book.image}
              alt={book.title[0]}
              style={{ width: "157px", height: "222px" }}
            />
            <div className="card-body">
              <h5 className="card-title">{book.title[0]}</h5>
              <p className="card-text">{book.genre}</p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default BookList;
